/* Mobile menu selection and overlay placement. The dock stays visible. */
(() => {
  const mobile = matchMedia('(max-width:749px)');
  let menuList;
  let headerMenuItems;
  let dockMenuActive = false;
  let correctingScroll = false;
  let scrollCheckQueued = false;

  const currentMenuList = () => {
    const current = document.querySelector('.mobile-menu .navigation-mobile');
    if (current !== menuList) {
      menuList = current;
      headerMenuItems = current ? Array.from(current.childNodes, (node) => node.cloneNode(true)) : null;
      dockMenuActive = false;
    }
    return current;
  };
  const restoreHeaderMenu = () => {
    const list = currentMenuList();
    if (dockMenuActive && list && headerMenuItems) {
      list.replaceChildren(...headerMenuItems.map((node) => node.cloneNode(true)));
      dockMenuActive = false;
    }
  };

  // A parent category is a navigation step, not a destination. On mobile each
  // step replaces the previous list with its direct children, as on Deghi.
  const menuPath = [];
  const directSubmenu = (item) => Array.from(item.children).find((child) => child.matches('ul.navigation-sub-menu'));
  const updateDrilldown = () => {
    const list = currentMenuList();
    const panel = list?.closest('.mobile-menu');
    const header = panel?.querySelector('.mp-menu-drill-header');
    if (!list || !header) return;

    list.querySelectorAll('.mp-menu-path, .mp-menu-child').forEach((item) => {
      item.classList.remove('mp-menu-path', 'mp-menu-child');
    });
    const current = menuPath[menuPath.length - 1];
    if (current && !list.contains(current)) menuPath.length = 0;
    const active = menuPath[menuPath.length - 1];
    list.classList.toggle('mp-menu-drilling', !!active);
    panel.classList.toggle('mp-menu-drilling', !!active);
    header.hidden = !active;
    if (!active) return;

    menuPath.forEach((item) => item.classList.add('mp-menu-path'));
    const submenu = directSubmenu(active);
    Array.from(submenu?.children || []).forEach((item) => item.classList.add('mp-menu-child'));
    header.querySelector('.mp-menu-drill-title').textContent = active.querySelector(':scope > .navigation-mobile-item-link > a')?.textContent.trim() || '';
    panel.querySelector('.mobile-menu-inner')?.scrollTo({ top: 0, behavior: 'instant' });
  };
  const resetDrilldown = () => {
    menuPath.forEach((item) => {
      const trigger = item.querySelector(':scope > .navigation-mobile-item-link > a');
      const arrow = item.querySelector(':scope > .navigation-mobile-item-link > button');
      trigger?.setAttribute('aria-expanded', 'false');
      arrow?.setAttribute('aria-expanded', 'false');
    });
    menuPath.length = 0;
    updateDrilldown();
  };

  // Return from a collection to the menu level that listed that collection.
  // The remembered trail disambiguates collections present in multiple menus;
  // a direct visit falls back to the first matching branch, then to menu root.
  const collectionPath = (href) => {
    try {
      const url = new URL(href, location.href);
      if (url.origin !== location.origin || !url.pathname.includes('/collections/') || url.pathname.includes('/products/')) return '';
      return url.pathname.replace(/\/+$/, '');
    } catch (_) {
      return '';
    }
  };
  const parentItems = (leaf) => {
    const parents = [];
    let item = leaf.closest('li.navigation-mobile-item')?.parentElement.closest('li.navigation-mobile-item');
    while (item) {
      parents.unshift(item);
      item = item.parentElement.closest('li.navigation-mobile-item');
    }
    return parents;
  };
  const itemTitle = (item) => item.querySelector(':scope > .navigation-mobile-item-link > a')?.textContent.trim() || '';
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.mobile-menu .navigation-mobile-item-link > a[href]');
    if (!link || !currentMenuList()?.contains(link) || directSubmenu(link.closest('li.navigation-mobile-item'))) return;
    const path = collectionPath(link.href);
    if (!path) return;
    try {
      sessionStorage.setItem('mp-mobile-collection-trail', JSON.stringify({
        path,
        titles: parentItems(link).map(itemTitle),
        source: dockMenuActive ? 'dock' : 'header'
      }));
    } catch (_) { /* Storage may be unavailable in a private browser. */ }
  }, true);
  document.addEventListener('click', (event) => {
    const back = event.target.closest('[data-mp-collection-menu-back]');
    if (!back || !mobile.matches) return;
    event.preventDefault();
    event.stopPropagation();
    const path = collectionPath(back.dataset.collectionPath || location.pathname);
    let remembered = null;
    try { remembered = JSON.parse(sessionStorage.getItem('mp-mobile-collection-trail') || 'null'); } catch (_) { /* Use the current menu. */ }
    if (remembered?.path !== path) remembered = null;
    const toggles = [
      document.querySelector('.head-slot-nav-mobile-link-wrapper .head-slot-nav-mobile-link'),
      document.querySelector('#mobile-dock .head-slot-nav-mobile-link')
    ];
    const preferred = remembered?.source === 'dock' ? toggles[1] : toggles[0];
    const toggle = [preferred, ...toggles].find((item) => item?.getClientRects().length);
    if (!toggle) return;
    if (!document.body.classList.contains('mobile-menu-open')) toggle.click();
    const list = currentMenuList();
    if (!list) return;
    const candidates = Array.from(list.querySelectorAll('.navigation-mobile-item-link > a[href]'))
      .filter((link) => collectionPath(link.href) === path);
    const leaf = candidates.find((link) =>
      remembered && JSON.stringify(parentItems(link).map(itemTitle)) === JSON.stringify(remembered.titles)
    ) || candidates[0];
    if (!leaf) return;
    menuPath.push(...parentItems(leaf));
    menuPath.forEach((item) => {
      item.querySelector(':scope > .navigation-mobile-item-link > a')?.setAttribute('aria-expanded', 'true');
      item.querySelector(':scope > .navigation-mobile-item-link > button')?.setAttribute('aria-expanded', 'true');
    });
    updateDrilldown();
    const focusTarget = menuPath.length
      ? list.closest('.mobile-menu')?.querySelector('.mp-menu-drill-back')
      : list.querySelector(':scope > .navigation-mobile-item > .navigation-mobile-item-link > a');
    focusTarget?.focus({ preventScroll: true });
  }, true);

  // Parent entries are actions without a destination: Enter and Space must
  // behave like a click, including when a menu level is nested.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const trigger = event.target.closest('.navigation-main .has-sub-menu > a[role="button"], .mobile-menu .navigation-mobile-item-link > a[role="button"]');
    if (!trigger || event.target !== trigger) return;
    event.preventDefault();
    trigger.click();
  });

  document.addEventListener('click', (event) => {
    const back = event.target.closest('.mp-menu-drill-back');
    if (back) {
      event.preventDefault();
      event.stopPropagation();
      const leaving = menuPath.pop();
      leaving?.querySelector(':scope > .navigation-mobile-item-link > a')?.setAttribute('aria-expanded', 'false');
      leaving?.querySelector(':scope > .navigation-mobile-item-link > button')?.setAttribute('aria-expanded', 'false');
      updateDrilldown();
      if (menuPath.length) back.focus();
      else leaving?.querySelector(':scope > .navigation-mobile-item-link > a')?.focus();
      return;
    }

    const trigger = event.target.closest('.mobile-menu .navigation-mobile-item-link > a, .mobile-menu .navigation-mobile-item-link-expand');
    const item = trigger?.closest('.navigation-mobile-item');
    if (!item || !directSubmenu(item)) return;
    event.preventDefault();
    event.stopPropagation();
    if (menuPath.includes(item)) return;
    menuPath.push(item);
    item.querySelector(':scope > .navigation-mobile-item-link > a')?.setAttribute('aria-expanded', 'true');
    item.querySelector(':scope > .navigation-mobile-item-link > button')?.setAttribute('aria-expanded', 'true');
    updateDrilldown();
    item.querySelector(':scope > ul.navigation-sub-menu a, :scope > ul.navigation-sub-menu button')?.focus({ preventScroll: true });
  }, true);

  // Keep the existing dropdown appearance on desktop, but never follow a
  // category link while that category has a deeper menu.
  const clearDesktopMenu = () => {
    document.querySelectorAll('.navigation-main .mp-menu-open').forEach((item) => {
      item.classList.remove('mp-menu-open', 'is-expanded');
      item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
    });
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.navigation-main .has-sub-menu > a');
    if (!trigger) {
      if (!event.target.closest('.navigation-main')) clearDesktopMenu();
      return;
    }
    const item = trigger.parentElement;
    if (!Array.from(item.children).some((child) => child.classList.contains('navigation-sub-menu'))) return;
    event.preventDefault();
    event.stopPropagation();
    if (item.classList.contains('mp-menu-open')) {
      item.querySelectorAll('.mp-menu-open').forEach((openItem) => {
        openItem.classList.remove('mp-menu-open', 'is-expanded');
        openItem.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
      });
      item.classList.remove('mp-menu-open', 'is-expanded');
      trigger.setAttribute('aria-expanded', 'false');
      return;
    }
    const menu = item.closest('.navigation-main');
    menu.querySelectorAll('.mp-menu-open').forEach((openItem) => {
      if (openItem === item || openItem.contains(item)) return;
      openItem.classList.remove('mp-menu-open', 'is-expanded');
      openItem.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
    });
    item.classList.add('mp-menu-open', 'is-expanded');
    trigger.setAttribute('aria-expanded', 'true');
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (menuPath.length && document.body.classList.contains('mobile-menu-open')) {
      event.preventDefault();
      document.querySelector('.mp-menu-drill-back')?.click();
    } else {
      clearDesktopMenu();
    }
  });
  document.addEventListener('click', (event) => {
    const dockToggle = event.target.closest('#mobile-dock .head-slot-nav-mobile-link');
    const headerToggle = event.target.closest('.head-slot-nav-mobile-link-wrapper .head-slot-nav-mobile-link');
    if (dockToggle && !document.body.classList.contains('mobile-menu-open')) {
      resetDrilldown();
      const template = document.querySelector('#mobile-dock template[data-mp-dock-menu]');
      const list = currentMenuList();
      if (template && list) {
        list.replaceChildren(template.content.cloneNode(true));
        dockMenuActive = true;
      }
    } else if (headerToggle && !document.body.classList.contains('mobile-menu-open')) {
      resetDrilldown();
      restoreHeaderMenu();
    }
  }, true);
  document.addEventListener('mobile-menu:open', () => {
    const toggle = document.querySelector('#mobile-dock .head-slot-nav-mobile-link');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    // The sticky header can still be sliding into view when the dock opens the
    // menu. Keep the panel above the dock as its viewport position settles.
    const panel = document.querySelector('.mobile-menu');
    let previousTop = null;
    let framesLeft = 30;
    const keepMenuAboveDock = () => {
      if (!panel || !document.body.classList.contains('mobile-menu-open')) return;
      const top = panel.getBoundingClientRect().top;
      if (previousTop === null || Math.abs(top - previousTop) > 0.5) {
        if (typeof setMobileMenuMaxheight === 'function') setMobileMenuMaxheight();
        previousTop = top;
      }
      if (--framesLeft > 0) requestAnimationFrame(keepMenuAboveDock);
    };
    requestAnimationFrame(keepMenuAboveDock);
  });
  document.addEventListener('mobile-menu:close', () => {
    const toggle = document.querySelector('#mobile-dock .head-slot-nav-mobile-link');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    resetDrilldown();
    restoreHeaderMenu();
  });
  window.addEventListener('resize', () => {
    if (document.body.classList.contains('mobile-menu-open') && typeof setMobileMenuMaxheight === 'function') setMobileMenuMaxheight();
  });

  // Keep the existing end-of-footer guard, independently of dock visibility.
  const pageEnd = () => {
    const footer = document.querySelector('footer.footer');
    if (!footer) return null;
    return Math.max(0, footer.getBoundingClientRect().bottom + window.scrollY - document.documentElement.clientHeight);
  };
  let footerNearViewport = !('IntersectionObserver' in window);
  const pageFooter = document.querySelector('footer.footer');
  if (pageFooter && 'IntersectionObserver' in window) {
    const footerObserver = new IntersectionObserver(([entry]) => {
      footerNearViewport = entry.isIntersecting;
    }, { rootMargin: '120px 0px' });
    footerObserver.observe(pageFooter);
  }
  window.addEventListener('scroll', () => {
    if (!mobile.matches || !footerNearViewport || correctingScroll || scrollCheckQueued || document.body.classList.contains('mobile-menu-open')) return;
    scrollCheckQueued = true;
    requestAnimationFrame(() => {
      scrollCheckQueued = false;
      if (!mobile.matches || correctingScroll || document.body.classList.contains('mobile-menu-open')) return;
      const end = pageEnd();
      if (end === null || window.scrollY <= end + 2 || getComputedStyle(document.body).overflowY === 'hidden') return;
      correctingScroll = true;
      window.scrollTo({ top: end, left: window.scrollX, behavior: 'instant' });
      requestAnimationFrame(() => { correctingScroll = false; });
    });
  }, { passive: true });

})();
